const
  appDefaultState = {
    mobile: false,
  },
  appReducer = (state = appDefaultState, action) => {
    switch (action.type) {
      case 'MOBILE':
        return Object.assign({}, state, { mobile: action.mobile });

      default:
        return state;
    }
  };

export { appDefaultState, appReducer };
